import React, { useEffect, useState } from "react";
import toastr from "toastr";
import { authFetch } from "../utils/authFetch";

const toast = (m, t = "success") => {
  toastr.options = {
    closeButton: true,
    progressBar: true,
    timeOut: 3000,
  };

  toastr[t](m);
};

export default function OnboardingSettlement() {
  const [merchantList, setMerchantList] = useState([]);
  const [selectedMerchant, setSelectedMerchant] = useState(null);

  const [walletBalance, setWalletBalance] = useState(0);

  const [settlementForm, setSettlementForm] = useState({
    amount: "",
  });

  const [balanceLoading, setBalanceLoading] = useState(false);
  const [settlementLoading, setSettlementLoading] = useState(false);

  // ==========================
  // COMMON POST API
  // ==========================

  const postApi = async (url, payload) => {
    const res = await authFetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(payload),
    });

    const data = await res.json();

    if (!res.ok) {
      throw new Error(data.message || "Request Failed");
    }

    return data;
  };

  // ==========================
  // LOAD MERCHANTS
  // ==========================

  const loadMerchants = async () => {
    try {
      const res = await authFetch(
        "/api/v1/member/topay/userlist"
      );

      const data = await res.json();

      setMerchantList(Array.isArray(data) ? data : []);
    } catch (err) {
      console.log(err);
      toast("Unable to load merchants", "error");
    }
  };

  // ==========================
  // WALLET BALANCE
  // ==========================

//   const getWalletBalance = async (
//     merchantId = selectedMerchant?.merchantId
//   ) => {
//     try {
//       if (!merchantId) {
//         return toast("Select Merchant", "warning");
//       }

//       setBalanceLoading(true);

//       const data = await postApi(
//         "/api/v1/member/topay/wallet-balance",
//         {
//           merchantId,
//         }
//       );

//       const balance =
//         data?.data?.wallets?.[0]?.availableBalance ||
//         data?.data?.wallets?.[0]?.balance ||
//         0;

//       setWalletBalance(balance);
//     } catch (err) {
//       console.log(err);
//       toast(err.message, "error");
//     } finally {
//       setBalanceLoading(false);
//     }
//   };

const getWalletBalance = async (
  merchantId = selectedMerchant?.merchantId
) => {
  try {

    const data = await postApi(
      "/api/v1/member/topay/wallet-balance",
      {
        merchantId,
      }
    );

    const generalWallet =
      data?.data?.result?.find(
        (item) => item.productId === "GENERAL"
      );

    setWalletBalance(
      Number(generalWallet?.balance || 0)
    );

  } catch (err) {
    toast(err.message, "error");
  }
};

  // ==========================
  // SELECT MERCHANT
  // ==========================

  const handleSelectMerchant = async (merchant) => {
    setSelectedMerchant(merchant);

    await getWalletBalance(
      merchant.merchantId
    );
  };

  // ==========================
  // SETTLEMENT
  // ==========================

  const handleSettlement = async () => {
    try {
      if (!selectedMerchant?.merchantId) {
        return toast("Select Merchant", "warning");
      }

      if (!settlementForm.amount) {
        return toast(
          "Enter Settlement Amount",
          "warning"
        );
      }

      setSettlementLoading(true);

      const data = await postApi(
        "/api/v1/member/topay/wallet-debit",
        {
          merchantId:selectedMerchant.merchantId,
          amount: settlementForm.amount,
          description: `Wallet Debit for UPI Merchant - ${selectedMerchant.merchantId}`,
          deviceInfo: selectedMerchant.deviceInfo,
        }
      );

      toast(
        data.message ||
          "Settlement Success"
      );

      setSettlementForm({
        amount: "",
      });

      getWalletBalance();
    } catch (err) {
      console.log(err);
      toast(err.message, "error");
    } finally {
      setSettlementLoading(false);
    }
  };

  // ==========================
  // INIT
  // ==========================

  useEffect(() => {
    loadMerchants();
  }, []);

  return (
    <div className="page-wrapper">
      <div className="page-content-wrapper">
        <div className="page-content">

          <div className="card">
            <div className="card-body">

              <h5>Topay Merchant List</h5>

              <hr />

              <div className="table-responsive">

                <table className="table table-bordered table-striped">

                  <thead>
                    <tr>
                        <th>#</th>
                        <th>Merchant ID</th>
                        <th>Name</th>
                        <th>Email</th>
                        <th>Mobile</th>
                        <th>Bank</th>
                        <th>Account No</th>
                        <th>IFSC</th>
                        <th>Branch</th>
                        <th>Action</th>
                    </tr>
                  </thead>

                  <tbody>

                    {merchantList.map(
                      (merchant, index) => (
                        <tr key={index}>
                          <td>
                            {index + 1}
                          </td>
                          <td>
                            <span className="badge bg-dark">
                              {
                                merchant.merchantId
                              }
                            </span>
                          </td>
                          <td>{merchant.name}</td>
                          <td>{merchant.email}</td>
                          <td>{merchant.mobile}</td>
                          <td>{merchant.bankName}</td>
                          <td>{merchant.accountno}</td>
                          <td>{merchant.ifscCode}</td>
                          <td>{merchant.branchName}</td>
                          <td>
                            <button
                              className="btn btn-sm btn-primary"
                              onClick={() =>
                                handleSelectMerchant(
                                  merchant
                                )
                              }
                            >
                              Select
                            </button>
                          </td>
                        </tr>
                      )
                    )}

                  </tbody>

                </table>

              </div>
            </div>
          </div>

          {selectedMerchant && (
            <div className="card mt-4">
              <div className="card-body">

                <h5>
                  Settlement -
                  {" "}
                  {selectedMerchant.name}
                </h5>

                <hr />

                {/* <div className="row mb-3">

                  <div className="col-md-3">

                    <button
                      className="btn btn-primary w-100"
                      onClick={
                        getWalletBalance
                      }
                      disabled={
                        balanceLoading
                      }
                    >
                      {balanceLoading
                        ? "Loading..."
                        : "Refresh Balance"}
                    </button>

                  </div>

                </div> */}

                <div className="alert alert-success">

                  <h5 className="mb-0">
                    Wallet Balance : ₹
                    {" "}
                    {walletBalance}
                  </h5>

                </div>

                <div className="row">

                  <div className="col-md-4">

                    <input
                      type="number"
                      className="form-control"
                      placeholder="Settlement Amount"
                      value={
                        settlementForm.amount
                      }
                      onChange={(e) =>
                        setSettlementForm({
                          amount:
                            e.target.value,
                        })
                      }
                    />

                  </div>

                  <div className="col-md-3">

                    <button
                      className="btn btn-success w-100"
                      onClick={
                        handleSettlement
                      }
                      disabled={
                        settlementLoading
                      }
                    >
                      {settlementLoading
                        ? "Processing..."
                        : "Settlement Request"}
                    </button>

                  </div>

                </div>

              </div>
            </div>
          )}

        </div>
      </div>
    </div>
  );
}